import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/outline";

export default function Resources() {
  return (
    <section>
      <h1 className="text-2xl font-bold mb-4">Getting help</h1>
      <p className="mb-4 text-gray-700">
        Whenfin is a new project and may be prone to errors or unexpected
        issues. If you run into trouble or have questions, please feel free to
        reach out to me. My contact information is available at my{" "}
        <a
          href="https://l-uca.com"
          target="_blank"
          rel="noopener noreferrer"
          className="text-indigo-600 hover:underline inline-flex items-center gap-1"
        >
          my personal website
          <ArrowTopRightOnSquareIcon className="w-4 h-4 inline" />
        </a>
        .
      </p>
      <p class="text-gray-700">
        I'm currently working to open-source the Whenfin codebase. Once
        complete, please report issues directly to the repo!
      </p>
    </section>
  );
}
